import type React from "react";

import data from "@emoji-mart/data";
import { init } from "emoji-mart";
import { styled } from "styled-components";

init({ data });

const SelectedContainer = styled.div<{
  $size?: number;
  $selected?: boolean;
  $canClick?: boolean;
}>`
  width: ${({ $size }) => ($size ? `${$size}px` : "20px")};
  height: ${({ $size }) => ($size ? `${$size}px` : "20px")};
  border-radius: 50%;
  background-color: ${({ theme, $selected }) =>
    $selected ? theme?.primaryColour || "#cacaca" : null};
  display: flex;
  justify-content: center;
  align-items: center;
  cursor: ${({ $canClick }) => ($canClick ? "pointer" : "inherit")};
  button,
  span {
    ${({ $canClick }) => ($canClick ? "pointer" : "inherit")};
  }
  ${({ $canClick }) =>
    $canClick &&
    `
    span {
      &:hover {
        opacity: 75%;
      }
    }
  `}

  > span {
    display: flex !important;
  }
`;

type EmojiComponentProps = {
  selected?: boolean;
  emoji: { id: string };
  onClick?: (emoji: any) => void;
  size?: number;
  style?: React.CSSProperties;
};

export const Emoji = ({
  selected,
  emoji,
  onClick,
  size,
  style,
  ...rest
}: EmojiComponentProps) => {
  return (
    <SelectedContainer
      $selected={selected}
      $canClick={!!onClick}
      $size={size}
      style={style}
      onClick={onClick ? () => onClick(emoji) : null}
    >
      <em-emoji
        id={emoji.id}
        size={size}
        style={{ display: "flex" }}
      ></em-emoji>
    </SelectedContainer>
  );
};
